import idx from "idx"
import { getSafeDataMap } from "@jsUtils"

/**
 * transform - manipulate data for contacts
 * @param {object} contactEmails - contactEmails query
 * @returns {object}
 */

function transform(contactEmails) {
  const contacts = getSafeDataMap(contactEmails, contact => {
    return {
      title: idx(contact, _ => _.title),
      description: idx(contact, _ => _.description),
      email: idx(contact, _ => _.email)
    }
  })
  return {
    contacts
  }
}

export default { transform }
